module.exports = __webpack_public_path__ + "img/foto-gustavo-cardoso.33d5cb32.jpg";